// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ZRal","requiredAsterisk":"Info_requiredAsterisk__31E_W"};